
















import Vue from "vue";
import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import EventBus from "@/utils/eventBus";
import * as types from "@/store/constants/types";
import { sendEvent } from "@/utils/analytics";

@Component({
  components: {}
})
export default class SloganView extends Vue {
  private destroyed() {
    EventBus.$off("restartSloganAnim");
  }

  private mounted() {
    sendEvent("uia_welcome_free_followers_show");
    EventBus.$on("restartSloganAnim", (payload: any) => {
      this.restartAnimation();
    });
    // const element = document.querySelector(".slogan_Ani1") as HTMLElement;
    // if (element) {
    //   element.addEventListener("webkitAnimationEnd", () => {
    //     console.log("webkitAnimationEnd slogan");
    //   });
    // }
  }

  private clickAction() {
    this.$emit("click");
  }

  private restartAnimation() {
    this.restartAnimCore("slogan_Layer1", "slogan_Ani1");
    this.restartAnimCore("slogan_Layer2", "slogan_Ani2");
    // this.restartAnimCore("slogan_Layer3", "slogan_Ani3");
  }

  private restartAnimCore(id: string, clsName: string) {
    const element = document.getElementById(id) as HTMLElement;
    const newone = element.cloneNode(true);
    const parentNode = element.parentNode;
    if (parentNode) {
      parentNode.replaceChild(newone, element);
    }

    if (element) {
      // reset the transition by...
      element.classList.remove(clsName);
      void element.offsetWidth;
      element.classList.add(clsName);
    }
  }
}
